<template>
	<div class="avatar-picture-virtual-watch">
		<div v-if="picture" :style="style" class="avatar-picture"></div>
		<shape src="/static/svg/watch/watch.svg" class="avatar-mask" :class="{ visible: picture }"/>
	</div>
</template>

<script>
import generateBase64Picture from '@/utils/generateBase64Picture'
export default {
	props: [
		'user_uid',
		'watch_id',
		'watch'
	],
	data () {
		return {
			name: 'avatar picture virtual watch'
		}
	},
	computed: {
		picture () {
			return this.watch.data.picture
		},
		style () {
			return `background-image:url('${this.picture}')`
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/avatars/AvatarPictureWatch.vue